<template>
  <div v-if="!loading">
    <div class="container">
      <ButtonsBack :to="{name: 'index'}" />
    </div>
    <SectionAboutUs
      :title="content?.title"
      :text="content?.intro"
      :button="{
        label: 'Bekijk vacatures',
        to: {name: 'vacatures'},
      }"
      half
    />
    <div class="rounded-tr-large bg-white">
      <div
        v-if="professions"
        class="container flex max-w-5xl flex-wrap gap-4 pt-16"
      >
        <NuxtLink
          v-for="item in professions"
          :key="item.title"
          :to="item.slug"
        >
          <UiTag type="outline">
            {{ item.title }}
          </UiTag>
        </NuxtLink>
      </div>
      <SofieText
        :value="content?.text"
        class="container prose max-w-5xl py-16"
      />
      <div class="py-16">
        <div class="container relative">
          <div
            class="w-full overflow-hidden rounded-3xl lg:h-[30rem]"
            :class="{'bg-beige-100': !content?.active_image}"
          >
            <NuxtPicture
              v-if="content?.active_image"
              :src="content.active_image.url"
              class="hidden object-cover lg:block"
            />
          </div>
          <RecruiterTile
            v-if="recruiter"
            white
            :recruiter="recruiter"
            class="lg:absolute lg:left-20 lg:top-20"
          />
        </div>
      </div>

      <div class="container py-16">
        <h2 class="mb-10">
          {{ content?.title }} vacatures
        </h2>
        <ul class="grid w-full gap-10 md:grid-cols-2">
          <VacancyTile
            v-for="similar in vacancies"
            :key="similar.id"
            show-excerpt
            :vacancy="similar"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useRouteQuery} from '@vueuse/router';
import vacancyLandingPageQuery from '~/graphql/queries/vacancyLandingPage.gql';
import type {Vacancy, Recruiter, Functie, PageContent} from '~/graphql/graphql.ts';

definePageMeta({
  header: {
    transparent: true,
    cream: true,
  },
  bg: 'bg-white',
});

const route = useRoute();
const routeSlug = computed(() => route.path.replace('/', ''));

const content = ref<PageContent>();
const vacancies = ref<Vacancy[]>([]);
const professions = ref<Functie[]>([]);
const recruiter = ref<Recruiter>({} as Recruiter);

const routeFilter = useRouteQuery<string>('filters');
const {onResult, loading} = useQuery(vacancyLandingPageQuery, {
  slug: routeSlug,
  filters: routeFilter.value ? JSON.parse(routeFilter.value) : {sector: [], hours: []},
  order: route.query?.order ?? 'salary',
}, {
  fetchPolicy: 'no-cache',
});

onResult((landingPageResult) => {
  if (landingPageResult.data.vacancyLandingPage === null) {
    showError({statusCode: 404});
  }
  content.value = landingPageResult.data.vacancyLandingPage.page;
  vacancies.value = landingPageResult.data.vacancyLandingPage.vacancies;
  professions.value = landingPageResult.data.vacancyLandingPage.professions;
  recruiter.value = landingPageResult.data.vacancyLandingPage.recruiter;
});
</script>
